module.exports = __webpack_public_path__ + "assets/Epsilon.a5d078093f076ba73903deb4751030db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Epsilon.png
// module id = 784
// module chunks = 0